export default {
  UPLOAD: 'VOD.FILE.UPLOAD',
  UPLOAD_VIDEO: 'VOD.FILE.UPLOAD_VIDEO',
  GET_VIDEO_DURATION: 'VOD.FILE.GET_VIDEO_DURATION',
  CAN_UPLOAD_VIDEO: 'VOD.FILE.CAN_UPLOAD_VIDEO',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/file.js